export default __webpack_public_path__ + "static/media/Logo.e2eac32f.png";